import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'tnc',
    defaultMessage: 'Syarat & Ketentuan',
  },
});
